<template>
    <v-container v-if="paciente">
        <v-container>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn id="boton-verde" min-width="220" 
                @click="esExterno() ? this.$router.push('/reintegros/home') : this.$router.push('elegibilidad')"
                block><v-icon icon="mdi mdi-arrow-left"></v-icon></v-btn>
            </v-col>
        </v-row>
        </v-container>
        <v-row>
            <v-col cols="12" md="12">
                <h2 class="titulo my-text ">Información del paciente</h2>
            </v-col>
        </v-row>
        
        <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit"> 
            <v-container>
                <v-divider id="divider" class="mt-4 mb-4"></v-divider>
                <v-row>
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="paciente.apellidoNombre"
                        label="Apellido y nombre"
                        variant="solo"
                        :readonly="!pedirDatosPaciente || validado"
                        required
                        :class="pedirDatosPaciente ? 'asterisco' : ''"
                        :rules="pedirDatosPaciente ? obligatorioAlfabetico : ''"
                        ></v-text-field>
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    >
                    <v-text-field
                        v-model="paciente.numeroAfiliado"
                        label="Número de afiliado"
                        variant="solo"
                        readonly
                    ></v-text-field>
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    >
                    <v-text-field
                        v-if="!obraSocialPorConfianza()"
                        v-model="paciente.tipoAfiliatorio"
                        label="Tipo afiliatorio"
                        variant="solo"
                        :readonly="!pedirDatosPaciente || validado"
                        required
                        :class="pedirDatosPaciente ? 'asterisco' : ''"
                        :rules="pedirDatosPaciente ? obligatorioAlfabetico : ''"
                    ></v-text-field>
                    <v-select
                        v-else
                        v-model="paciente.planAfiliatorioId"
                        label="Plan de afiliación"
                        item-title="nombre"
                        item-value="id"
                        variant="solo"
                        :items="tiposAfiliatorios"
                        :rules="obligatorio"
                        required
                        class="asterisco"
                        :loading="cargandoTiposAfiliatorios"
                        :readonly="validado"
                    ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    md="6"
                    >
                        <v-text-field
                        v-model="paciente.partidoDescripcion"
                        label="Partido"
                        variant="solo"
                        :readonly="!pedirDatosPaciente || validado"
                        required
                        :class="pedirDatosPaciente ? 'asterisco' : ''"
                        :rules="pedirDatosPaciente ? obligatorioAlfanumerico : ''"
                        ></v-text-field>
                    </v-col>
                    <v-col
                    cols="12"
                    md="6"
                    >
                        <v-text-field
                        v-model="paciente.localidadDescripcion"
                        label="Localidad"
                        variant="solo"
                        :readonly="!pedirDatosPaciente || validado"
                        required
                        :class="pedirDatosPaciente ? 'asterisco' : ''"
                        :rules="pedirDatosPaciente ? obligatorioAlfanumerico : ''"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    md="6"
                    v-if="obraSocialPorConfianza()"
                    >
                        <ImageInput
                            v-model:imagenes="paciente.carnetAfiliado"
                            :obligatorio="this.$store.getters.getObraSocial.configuracionOS.requiereCarnetAfiliado"
                            :readonly="!pedirDatosPaciente || validado"
                            nombreImagen="Imagen del carnet de afiliado"
                            :label="'Carnet de afiliado'"
                            :tipoDocumentacion="3"
                        >
                        </ImageInput>
                    </v-col>
                    <v-col
                    cols="12"
                    md="6"
                    v-if="obraSocialPorConfianza()"
                    >
                        <VueDatePicker
                            v-model="paciente.vencimientoCarnet"
                            :enableTimePicker="false"
                            :auto-apply="true"
                            :min-date="new Date()"
                            :format-locale="es"
                            :format="date => date ? date.getDate()+ '/' + (date.getMonth() + 1) + '/' + date.getFullYear() : ''"
                            cancel-text="Cancelar"
                            select-text="Aplicar"
                            :teleport="true"
                            :day-names="['Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab', 'Dom']"
                            placeholder="Vencimiento del carnet"
                            class="datepicker-input"
                            @update:modelValue="actualizarMsjError"
                            :readonly="!pedirDatosPaciente || validado"
                        />
                        <p v-if="erroresFecha" class="error-message">{{ erroresFecha }}</p>
                    </v-col>
                </v-row>
                <v-row v-if="!esExterno()">
                    <v-col
                    cols="12"
                    md="6"
                    >   
                        <p class="font-weight-light text-h6">Paciente ingresado por: <span class="my-text-black">{{ this.$store.getters.getIngreso.descripcion }}</span></p>                    
                    </v-col>
                </v-row>
                <v-divider id="divider" class="mt-4 mb-4"></v-divider>
                <v-row>
                    <h4 class="my-text-black"><v-icon>mdi-information</v-icon> {{esExterno() ? "Datos extras:" : "Datos de contacto:"}}</h4>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="paciente.mail"
                        label="Correo electrónico"
                        hide-details="auto"
                        variant="solo"
                        :rules="esExterno() ? obligatorioMail : opcionalMail"
                        :readonly="validado"
                        :class="esExterno() ? 'asterisco' : ''"
                        ></v-text-field>
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="paciente.telefono"
                        label="Teléfono"
                        hide-details="auto"
                        variant="solo"
                        :rules="(esExterno() || permitePesadas()) ? obligatorioNumerico : opcionalNumerico"
                        :readonly="validado"
                        :class="(esExterno() || permitePesadas())? 'asterisco' : ''"
                        ></v-text-field>
                    </v-col>
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="cbuOdireccion"
                        :label="esExterno() ? 'CBU/alias' : 'Dirección'"
                        :rules="esExterno() ? obligatorioCbuOalias : opcionalAlfaNumerico"
                        hide-details="auto"
                        variant="solo"
                        :readonly="validado"
                        :class="esExterno() ? 'asterisco' : ''"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-btn class="mt-8" id="boton-verde" type="submit" block v-if="!validado" :disabled="!valid || cargando || (obraSocialPorConfianza() && !fechaValida)" :loading="cargando">Continuar</v-btn>
            </v-container>
        </v-form>
        <AlertComponent
            :title="alertTitle"
            :text="alertText"
            :alertType="alertType"
            :showAlert="showAlert"
            @close="showAlert = false"
        ></AlertComponent>
        <PrestacionForm v-if="validado == true && !esExterno()">
        </PrestacionForm>
        <ReintegroForm 
            v-if="validado == true && esExterno()"
            @reiniciarValidacion="validado = false"
        >
        </ReintegroForm>
    </v-container>
    <p v-else class="my-text">No existe el usuario.</p>
</template>

<style src="../assets/general.css"></style>

<script>
    /* eslint-disable */
    import PacienteLight from "@/interfaces/pacienteInterfaces"
    import PrestacionForm from "./PrestacionForm.vue";
    import PacienteService from "@/api/PacienteService";
    import ReintegroForm from "./ReintegroForm.vue";
    import ImageInput from "@/components/ImageInput.vue";
    import AlertComponent from "./AlertComponent.vue";
    import { Role } from "@/_helpers/role"
    import { obligatorio, obligatorioNumerico, obligatorioMail, opcionalMail, opcionalNumerico, opcionalAlfaNumerico, obligatorioAlfanumerico, obligatorioCbuOalias,obligatorioAlfabetico} from "@/_helpers/rules";
    
    const pacienteService = new PacienteService();

    export default {
        components: {
            PrestacionForm,
            ReintegroForm,
            ImageInput,
            AlertComponent
        },
        data: () => ({
            valid: false,
            validado: false,
            paciente : PacienteLight = {
                vencimientoCarnet : null
            },
            pedirDatosPaciente: false,
            obligatorio: obligatorio,
            obligatorioNumerico: obligatorioNumerico,
            obligatorioMail: obligatorioMail,
            opcionalNumerico: opcionalNumerico,
            opcionalMail: opcionalMail,
            opcionalAlfaNumerico: opcionalAlfaNumerico,
            obligatorioAlfanumerico: obligatorioAlfanumerico,
            obligatorioAlfabetico: obligatorioAlfabetico,
            obligatorioCbuOalias: obligatorioCbuOalias,
            cbuOdireccion: null,
            tiposAfiliatorios: [],
            cargandoTiposAfiliatorios: false,
            cargando: false,
            erroresFecha: null,
            fechaValida: false,
            //datos para mostrar alerta
            alertTitle: "",
            alertText: "",
            alertType: "",
            showAlert: false
        }),
        async mounted() {
            if(!this.esExterno()){
                this.pedirDatosPaciente = this.$store.getters.getPedirDatosPaciente;
            }
            this.initializePaciente();
            await this.getTiposAfiliatorios();
            this.actualizarMsjError();
        },
        methods: {
            async handleSubmit() {
                this.cargando = true;
                if(this.valid){
                    this.paciente.pacienteId = this.paciente.id;
                    this.esExterno() ? this.paciente.cbu = this.cbuOdireccion : this.paciente.direccion = this.cbuOdireccion;
                    this.$store.commit('setPlanAfiliatorio', this.paciente.tipoAfiliatorio);
                    const response = await pacienteService.postDatosAdicionales(this.paciente);
                    if(response && response.status === 200){
                        this.validado = true;
                        this.actualizarPaciente();
                        if(!response.data.exito){
                            this.alertTitle = 'Inconveniente al cargar datos adicionales';
                            this.alertText = response.data.mensaje ? response.data.mensaje : 'Ocurrió un inconveniente al cargar los datos adicionales del paciente.';
                            this.alertType = 'info';
                            this.showAlert = true;
                        }
                    } else{
                        this.alertTitle = 'Error al cargar datos adicionales';
                        this.alertText = response.data.mensaje ? response.data.mensaje : 'Ocurrió un error al cargar los datos adicionales del paciente.';
                        this.alertType = 'error';
                        this.showAlert = true;
                    }
                }
                this.cargando = false;
            },
            initializePaciente() {
                this.paciente = this.$store.getters.getPaciente;
                this.paciente.planAfiliatorioId = this.paciente.plan ? this.paciente.plan.id : null;
                this.esExterno() ? this.cbuOdireccion = this.paciente.cbu : this.cbuOdireccion = this.paciente.direccion;
            },
            actualizarPaciente(){
                this.$store.commit('setPaciente', this.paciente);
            },
            itemTitleNroAfiliado() {
                return `${this.paciente.numeroAfiliado} - ${this.paciente.tipoAfiliatorio}`;
            },
            async getTiposAfiliatorios() {
                this.cargandoTiposAfiliatorios = true;
                const response = await pacienteService.getPlanesObraSocial(this.$store.getters.getObraSocial.id);
                if(response && response.status === 200){
                    this.tiposAfiliatorios = response.data;
                    this.cargandoTiposAfiliatorios = false;
                }
            },
            esExterno(){
                return this.$store.getters.getRole == Role.Paciente;
            },
            obraSocialPorConfianza(){
                return this.$store.getters.getObraSocial.configuracionOS.tipoServicio == 3;
            },
            actualizarMsjError(){
                if(this.paciente.vencimientoCarnet || !this.$store.getters.getObraSocial.configuracionOS.requiereCarnetAfiliado){
                    this.erroresFecha = null;
                    this.fechaValida = true;
                }
                else{
                    this.erroresFecha = "Se requiere ingresar una fecha.";
                    this.fechaValida = false;
                }
            },
            permitePesadas(){
                return this.$store.getters.getObraSocial.configuracionOS.aceptaPracticaPesada;
            }
        }, 
    };
</script>